import { createContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import axios from 'axios';

const api = createContext();

const ApiProvider = ({ children }) => {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(() => i18n.language);
  const [formMessage, setFormMessage] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const apiURL = process.env.REACT_APP_API_URL

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
    window.location.reload()
  };

  useEffect(() => {
    if (language === "en") {
      document.getElementById("App").style.fontFamily = "Alata";
    } else if (language === "ar") {
      document.getElementById("App").style.fontFamily = "Alata";
    } else {
      document.getElementById("App").style.fontFamily = "Alata";
    }
  }, [language]);

  const handleSubmit = async (name, email, number, message, setName, setEmail, setNumber, setMessage) => {
    if (name && email && number && message) {
      // Validation Regex Patterns
      const regexPatterns = {
        name: /^[a-zA-Z\u0600-\u06ff ]{2,30}$/,
        email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        number: /^\+?\d{1,4}?\d{6,14}$|^\+?\d{1,4}?[\u0660-\u0669]{6,14}$|^[+]?[\u0600-\u06ff\s]{6,14}$|^[+]?[\u0600-\u06ff\s]{6,14}[\u0660-\u0669]{0,14}$/ 
      };
    
      // Error Messages
      const errorMessages = [];
      
      // Validate Name
      if (!regexPatterns.name.test(name)) {
        errorMessages.push(t("validate_name"));
      }
    
      // Validate Email
      if (!regexPatterns.email.test(email)) {
        errorMessages.push(t("validate_email"));
      }
    
      // Validate Phone Number
      if (!regexPatterns.number.test(number)) {
        errorMessages.push(t("validate_number"));
      }
    
      // Validate Message Length
      if (message.trim().length < 10) {
        errorMessages.push(t("validate_message"));
      }
    
      // Display Errors or Submit
      if (errorMessages.length > 0) {
        setFormMessage({
          message: errorMessages,
          color: "red"
        });
        return;
      }
      setIsLoading(true)
      // If all validations pass 
      await axios.post(apiURL, {
        name,
        email,
        number,
        message,
      }, {
          headers: {
              'Content-Type': 'application/json',
          },
      })
      .then((response) => {
          if (response.status === 200) {
            setFormMessage({
                message: [t("message_success")],
                color: 'green',
            });
            setName("")
            setEmail("")
            setNumber("")
            setMessage("")
            setIsLoading(false)
          } else {
            setFormMessage({
                message: [t("message_failure")],
                color: 'red',
            });
            console.log(response.data)
            setName("")
            setEmail("")
            setNumber("")
            setMessage("")
            setIsLoading(false)
          }
      })
      .catch((error) => {
          setFormMessage({
              message: [t("message_failure")],
              color: 'red',
          });
          console.log(error)
          setName("")
          setEmail("")
          setNumber("")
          setMessage("")
          setIsLoading(false)
      });
    };
  }

  return (
    <api.Provider value={{ 
        changeLanguage,
        t,
        language,
        handleSubmit,
        formMessage,
        setFormMessage,
        isLoading
        }}>
      {children}
    </api.Provider>
  );
};

export default ApiProvider
export { api }